module.exports = __webpack_public_path__ + "static/img/moveEEC.b255f819.png";